<template>
  <v-select v-bind="$attrs"
            :placeholder="placeholder"
            :class="$style.select"
            :attach="isMobilePlatform"
            append-icon="keyboard_arrow_down"
            color="#38AA3F"
            @change="dataChanged"
            v-on="$listeners"/>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter } from 'vuex-class/lib/bindings';

/**
 * Select field element.
 */
@Component({
  inheritAttrs: false,
  props:        {
    placeholder: {
      type:     [ String, Number ],
      required: false,
      default:  '',
    },
  },
})
export default class SelectField extends Vue {
  @Getter isMobilePlatform;

  dataChanged(data) {
    this.$emit('dataChanged', data);
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
@import "~@/style/helpers.scss";

.select input {
  font-family: $main-font-family;
  font-size: rem(13px);
  font-weight: 300;
}
</style>




// WEBPACK FOOTER //
// src/components/SelectField.vue